import { createTheme } from '@mui/material/styles';
import { brandColors } from '@/theme/brandColors';

const bg = '#FBF7F2';
const surface = '#ffffff';
const border = '#EAE0D4';
const textPrimary = '#2B1D16';
const textMuted = '#6F6055';

export const immoTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brandColors.primary,
      dark: brandColors.primaryDark,
      light: brandColors.primaryLight,
      contrastText: '#fff',
    },
    success: { main: '#16a34a' },
    warning: { main: '#F59E0B' },
    error: { main: '#F43F5E' },
    background: {
      default: bg,
      paper: surface,
    },
    text: {
      primary: textPrimary,
      secondary: textMuted,
    },
    divider: border,
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Inter", system-ui, sans-serif',
    h1: {
      fontFamily: '"Space Grotesk", "Inter", system-ui, sans-serif',
      fontSize: '1.5rem',
      fontWeight: 700,
      letterSpacing: '-0.02em',
      color: textPrimary,
    },
    h2: {
      fontFamily: '"Space Grotesk", "Inter", system-ui, sans-serif',
      fontSize: '1.125rem',
      fontWeight: 600,
    },
    body1: { fontSize: '0.875rem', lineHeight: 1.55, color: '#3F352E' },
    body2: { fontSize: '0.875rem', lineHeight: 1.55 },
    caption: {
      fontSize: '0.6875rem',
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      // WCAG AA: warmer Grauton #6F6055 auf weiß ≈ 5.8:1 ✓
      color: '#6F6055',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@keyframes mui-auto-fill': { from: { display: 'block' } },
        '@keyframes mui-auto-fill-cancel': { from: { display: 'block' } },
        html: { overflowX: 'hidden' },
        body: {
          backgroundColor: bg,
          paddingLeft: 'env(safe-area-inset-left)',
          paddingRight: 'env(safe-area-inset-right)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            animationName: 'mui-auto-fill',
            animationDuration: '5000s',
          },
          '&:not(:-webkit-autofill)': {
            animationName: 'mui-auto-fill-cancel',
            animationDuration: '5000s',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 10,
          paddingInline: 14,
          transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, transform 0.2s ease, box-shadow 0.2s ease',
        },
        sizeSmall: { fontSize: '0.8125rem' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
  },
});
